module.exports = __webpack_public_path__ + "img/62b24b1.png";